/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import React from "react";

// Material Components
import { Autocomplete, InputAdornment } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

// Common Commponents
import pxToRem from "assets/theme/functions/pxToRem";

// Utils
import { Icons } from "utils/Constants";

export default function CustomSearch({
  isLoading,
  handleFilterChange,
  options,
  value,
  debouncedHandleSearch,
  placeholder,
  label = "Search",
  width = pxToRem(300),
  marginRight = 2,
  freeSolos,
  error,
  helperText,
  disabled,
  showSearchIcon = true,
  renderOption,
}) {
  const getLabel = (option) => {
    if (typeof option === "string") return option;
    return option?.title || "";
  };

  return (
    <MDBox
      display="flex"
      alignItems="start"
      sx={{ flexDirection: "column", marginRight, mt: pxToRem(4) }}
    >
      <MDTypography
        variant="caption"
        mb={1}
        sx={{ fontSize: pxToRem(12.5), fontWeight: 600, color: "#344054" }}
      >
        {label}
      </MDTypography>
      <Autocomplete
        disablePortal
        freeSolo={freeSolos}
        disabled={disabled}
        id="combo-box-demo"
        options={options || []}
        value={value}
        getOptionLabel={getLabel}
        isOptionEqualToValue={(option, selectedValue) =>
          getLabel(option) === getLabel(selectedValue)
        }
        renderOption={(props, option) =>
          renderOption ? renderOption(props, option) : <li {...props}>{getLabel(option)}</li>
        }
        noOptionsText="No data found"
        sx={{
          width,
          border: "none",
          "& .MuiOutlinedInput-root": {
            padding: 0,
            height: 32,
            backgroundColor: "#fff",
            paddingX: "8px !important",
            fontSize: pxToRem(13),
            fontWeight: 400,
            color: "#344054",
          },
        }}
        renderInput={(params) => (
          <MDInput
            {...params}
            placeholder={placeholder}
            pr={0}
            error={error}
            helperText={helperText}
            FormHelperTextProps={{
              sx: { marginLeft: 0, marginTop: 1, color: "red" },
            }}
            sx={{ textTransform: "capitalize", border: "none" }}
            InputProps={{
              ...params.InputProps,
              endAdornment: showSearchIcon ? (
                <InputAdornment position="end">
                  {isLoading ? Icons.LOADING : Icons.SEACRH}
                </InputAdornment>
              ) : null,
            }}
          />
        )}
        onChange={(event, selectedOption) => {
          if (handleFilterChange) {
            handleFilterChange(event, getLabel(selectedOption), selectedOption);
          }
        }}
        onKeyUp={debouncedHandleSearch}
      />
    </MDBox>
  );
}
